import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiGenerateSqlQueryVariables = Types.Exact<{
  input: Types.AIGenerateSqlQueryInput;
}>;

export type RunAiGenerateSqlQuery = {
  aiGenerateSqlQuery: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiGenerateSqlQueryDocument = gql`
  mutation RunAiGenerateSqlQuery($input: AIGenerateSqlQueryInput!) {
    aiGenerateSqlQuery(input: $input) {
      streamName
      streamId
      pinned
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiGenerateSqlQueryMutationFn = Apollo.MutationFunction<
  RunAiGenerateSqlQuery,
  RunAiGenerateSqlQueryVariables
>;

/**
 * __useRunAiGenerateSqlQuery__
 *
 * To run a mutation, you first call `useRunAiGenerateSqlQuery` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiGenerateSqlQuery` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiGenerateSqlQuery, { data, loading, error }] = useRunAiGenerateSqlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiGenerateSqlQuery(
  baseOptions?: Apollo.MutationHookOptions<RunAiGenerateSqlQuery, RunAiGenerateSqlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAiGenerateSqlQuery, RunAiGenerateSqlQueryVariables>(
    RunAiGenerateSqlQueryDocument,
    options,
  );
}
export type RunAiGenerateSqlQueryHookResult = ReturnType<typeof useRunAiGenerateSqlQuery>;
export type RunAiGenerateSqlQueryMutationResult = Apollo.MutationResult<RunAiGenerateSqlQuery>;
export type RunAiGenerateSqlQueryMutationOptions = Apollo.BaseMutationOptions<
  RunAiGenerateSqlQuery,
  RunAiGenerateSqlQueryVariables
>;
export function mockRunAiGenerateSqlQuery({
  data,
  variables,
  errors,
}: {
  data: RunAiGenerateSqlQuery;
  variables?: RunAiGenerateSqlQueryVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiGenerateSqlQueryDocument, variables },
    result: { data, errors },
  };
}
